// export const API_BASE_URL = 'https://promo-api.luftdigital.com.br';
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
